__turbopack_context__.v({
  "buttons": "FilterButtons-module-sass-module__pNSljW__buttons",
  "remove": "FilterButtons-module-sass-module__pNSljW__remove",
  "save": "FilterButtons-module-sass-module__pNSljW__save",
  "save-text": "FilterButtons-module-sass-module__pNSljW__save-text",
});
